import axios from "axios";

const GOOGLE_BASE = import.meta.env.VITE_GOOGLE_BASE

const api = axios.create({
  baseURL: GOOGLE_BASE,
  withCredentials: true,
});

export const getUser = async () => {
  try {
    const res = await api.get("/auth/me");
    return res.data;
  } catch (err) {
    return null;
  }
};